import * as React from 'react';
import type { StrictOmit } from '~/Partials/Utils/typeUtils';
import type { Theme } from '~/Utils/Theme';
import type { FormFastFieldProps } from './FormFastField';
import { FormFastField } from './FormFastField';
import type { FormFieldTypeSelectProps } from './FormFieldsTypes/FormFieldTypeSelect';
import { FormFieldTypeSelect } from './FormFieldsTypes/FormFieldTypeSelect';
import type { FormFieldValidate } from './validators';

export interface FormFieldSelectProps
    extends StrictOmit<FormFieldTypeSelectProps, 'value' | 'onChange' | 'onBlur'>,
        Pick<FormFastFieldProps, 'shouldUpdate'> {
    errorMessage?: string | React.ReactChild;
    className?: string;
    validate?: FormFieldValidate<string>;
    validateFieldOnFieldChange?: boolean;
    validateFieldOnFieldBlur?: boolean;
    onAfterBlur?: (val: string) => void;
    theme?: Theme;
    isDisabled?: boolean;
}

export class FormFieldSelect extends React.PureComponent<FormFieldSelectProps> {
    static displayName = 'FormWizard.FormFieldSelect';

    render() {
        const {
            name,
            label,
            className,
            onAfterBlur,
            validate,
            validateFieldOnFieldBlur = true,
            validateFieldOnFieldChange = false,
            theme,
            shouldUpdate,
            isDisabled,
            ...selectProps
        } = this.props;

        return (
            <FormFastField
                key={isDisabled ? 'disabled' : 'enabled'}
                validate={validate}
                name={name}
                onAfterBlur={onAfterBlur}
                validateFieldOnFieldBlur={validateFieldOnFieldBlur}
                validateFieldOnFieldChange={validateFieldOnFieldChange}
                shouldUpdate={shouldUpdate}
            >
                {({ inputProps, showError, errorMessage }) => (
                    <FormFieldTypeSelect
                        errorMessage={errorMessage}
                        showErrorMessage={showError}
                        className={className}
                        label={label}
                        theme={theme}
                        required={!!validate}
                        isDisabled={isDisabled}
                        {...selectProps}
                        {...inputProps}
                    />
                )}
            </FormFastField>
        );
    }
}
